/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UtpSimServiceApi', ($http, ApiErrorService) => {
    return {
        getMostRecentSimulatorInstances: getMostRecentSimulatorInstances,
        getAllSimulators: getAllSimulators,
        isAlreadyrunningInstance: isAlreadyrunningInstance,
        getAllActiveSimulatorInstances: getAllActiveSimulatorInstances,
        getRunningSimulatorsList: getRunningSimulatorsList,
        getCountOfRunningSimulators: getCountOfRunningSimulators,
        testApi: testApi,
        testApiDBConnection: testApiDBConnection,
        testApiAdminService: testApiAdminService,
        killProcess: killProcess,
        stopSimulatorInstance: stopSimulatorInstance,
        startSimulator: startSimulator,
        commsStart: commsStart,
        isSimulatorActive: isSimulatorActive,
        getActiveSimulatorStatus: getActiveSimulatorStatus,
        isSimulatorRunning: isSimulatorRunning,
        getSimulatorReports: getSimulatorReports,
        commsStop: commsStop,
        simHasICSQuestions: simHasICSQuestions,
        processTestScopeUpdate: processTestScopeUpdate,
        isSimLinkedToClearingSim: isSimLinkedToClearingSim
    };
    function getMostRecentSimulatorInstances(limitPerSim) {
        return $http.get(`api/UtpSim/GetMostRecentSimulatorInstances?limitPerSim=${limitPerSim}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllSimulators(userId, filterExternal, filterTemplate, filterSecondarySimulators, filterInactiveSimulators) {
        return $http.get(`api/UtpSim/GetAllSimulators?userId=${userId}&filterExternal=${filterExternal}&filterTemplate=${filterTemplate}&filterSecondarySimulators=${filterSecondarySimulators}&filterInactiveSimulators=${filterInactiveSimulators}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function isAlreadyrunningInstance(simId, userId) {
        return $http.get(`api/UtpSim/IsAlreadyrunningInstance?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllActiveSimulatorInstances() {
        return $http.get(`api/UtpSim/GetAllActiveSimulatorInstances`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getRunningSimulatorsList() {
        return $http.get(`api/UtpSim/GetRunningSimulatorsList`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getCountOfRunningSimulators() {
        return $http.get(`api/UtpSim/GetCountOfRunningSimulators`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function testApi() {
        return $http.get(`api/UtpSim/TestApi`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function testApiDBConnection() {
        return $http.post(`api/UtpSim/TestApiDBConnection`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function testApiAdminService() {
        return $http.post(`api/UtpSim/TestApiAdminService`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function killProcess(processId, simId, serverControllerId) {
        return $http.post(`api/UtpSim/KillProcess?processId=${processId}&simId=${simId}&serverControllerId=${serverControllerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function stopSimulatorInstance(simId, userId) {
        return $http.post(`api/UtpSim/StopSimulatorInstance?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function startSimulator(simulatorId, userId) {
        return $http.post(`api/UtpSim/StartSimulator?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function commsStart(simId) {
        return $http.post(`api/UtpSim/CommsStart?simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function isSimulatorActive(simId, userId) {
        return $http.get(`api/UtpSim/IsSimulatorActive?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getActiveSimulatorStatus(simId, userId) {
        return $http.get(`api/UtpSim/GetActiveSimulatorStatus?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function isSimulatorRunning(userId, simId) {
        return $http.get(`api/UtpSim/IsSimulatorRunning?userId=${userId}&simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorReports(simId, userId) {
        return $http.get(`api/UtpSim/GetSimulatorReports?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function commsStop(simId) {
        return $http.post(`api/UtpSim/CommsStop?simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function simHasICSQuestions(simId, userId) {
        return $http.get(`api/UtpSim/SimHasICSQuestions?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function processTestScopeUpdate(userId, simId) {
        return $http.get(`api/UtpSim/ProcessTestScopeUpdate?userId=${userId}&simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function isSimLinkedToClearingSim(userId, simId) {
        return $http.get(`api/UtpSim/IsSimLinkedToClearingSim?userId=${userId}&simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
